"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var AppContext_1 = require("../../../utility/AppContext");
var AppEnums_1 = require("../../../../shared/constants/AppEnums");
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b, _c, _d, _e, _f, _g;
    var _h = (0, react_1.useContext)(AppContext_1.default), themeStyle = _h.themeStyle, footer = _h.footer;
    return {
        appMain: (_a = {
                height: '100vh',
                display: 'flex',
                flexDirection: 'row',
                position: 'relative',
                backgroundColor: theme.palette.background.default,
                paddingTop: 56
            },
            _a[theme.breakpoints.up('sm')] = {
                paddingTop: 70,
            },
            _a['&.appMainFixedFooter'] = (_b = {
                    paddingBottom: 48
                },
                _b[theme.breakpoints.up('xl')] = {
                    paddingBottom: 58,
                },
                _b['& .scrollAppSidebar'] = (_c = {
                        height: themeStyle === AppEnums_1.ThemeStyle.MODERN
                            ? 'calc(100vh - 260px) !important'
                            : 'calc(100vh - 198px) !important'
                    },
                    _c[theme.breakpoints.up('xl')] = {
                        height: themeStyle === AppEnums_1.ThemeStyle.MODERN
                            ? 'calc(100vh - 300px) !important'
                            : 'calc(100vh - 236px) !important',
                    },
                    _c),
                _b['& $mainContainer'] = {
                    paddingBottom: 1,
                },
                _b),
            _a),
        mainContent: {
            flex: 1,
            display: 'flex',
        },
        mainContainer: (_d = {
                paddingBottom: footer ? 0 : 10,
                width: '100%'
            },
            _d[theme.breakpoints.up('lg')] = {
                width: "calc(100vw - 19rem)",
            },
            _d[theme.breakpoints.up('xl')] = {
                width: "calc(100vw - 21.6rem)",
            },
            _d['& > .scrollbar-container'] = (_e = {
                    padding: '20px 20px 0',
                    display: 'flex',
                    flexDirection: 'column'
                },
                _e[theme.breakpoints.up('md')] = {
                    padding: '30px 32px 0',
                },
                _e),
            _d),
        mainContainerFull: {
            width: '100vw',
            paddingBottom: footer ? 0 : 10,
            '& > .scrollbar-container': (_f = {
                    padding: '20px 20px 0',
                    display: 'flex',
                    flexDirection: 'column'
                },
                _f[theme.breakpoints.up('md')] = {
                    padding: '30px 32px 0',
                },
                _f),
        },
        boxedLayout: (_g = {},
            _g[theme.breakpoints.up('lg')] = {
                maxWidth: 1260,
                marginLeft: 'auto',
                marginRight: 'auto',
                boxShadow: '0px 0px 4px 2px rgba(0,0,0,0.12)',
                '& .app-sidebar': {
                    position: 'absolute',
                },
                '& .fixed-footer': {
                    maxWidth: 1260,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    right: 0,
                },
                '& $mainContent': {
                    width: '100%',
                    flex: 'auto',
                },
                '& $mainContainer': {
                    width: 'calc(100% - 19rem)',
                },
                '& .app-bar': {
                    width: '100%',
                    position: 'absolute',
                    boxShadow: '0px 0px 4px 2px rgba(0,0,0,0.12)',
                },
                '& .grid-btn': {
                    fontSize: 11,
                },
            },
            _g[theme.breakpoints.up('xl')] = {
                maxWidth: 1680,
                '& $mainContent, & .app-bar': {
                    width: '100%',
                },
                '& .fixed-footer': {
                    maxWidth: 1680,
                },
            },
            _g),
    };
});
exports.default = useStyles;
//# sourceMappingURL=index.style.js.map